import { type RootState } from "../../redux/store";
import { createSelector } from "reselect";
import { type NavigationNode } from "../types";

const EMPTY_LIST: any[] = [];

const selectNavigationNodes = (state: RootState) => state.navigation.categoryNavigation.nodes;
const selectRootNavigationIds = (state: RootState) => state.navigation.categoryNavigation.root?.children ?? EMPTY_LIST;
const selectSelectedNavIds = (state: RootState) => state.navigation.selectedNavIds;
export const selectNavigationBigImage = (state: RootState) => state.navigation.selectedImage;

export const selectMobileVisibleParentNodes = (state: RootState) => {
  const desktopList = selectDesktopVisibleParentNodes(state);

  const rootNode = state.navigation.categoryNavigation.root;

  return [{ curr: rootNode }, ...desktopList];
};

export const selectDesktopVisibleParentNodes = (state: RootState) => {
  const selectedIds = selectSelectedNavIds(state);
  const allNodes = selectNavigationNodes(state);
  const currNodes = selectedIds.map((id) => allNodes[id]);
  const prevNodes = state.navigation.previousSelectedNavIds.map((id) => allNodes[id]);

  const mergedList: { curr?: NavigationNode; prev?: NavigationNode }[] = [];
  for (let i = 0; ; i++) {
    const curNode = currNodes[i];
    const prevNode = prevNodes[i];

    if (!curNode && !prevNode) {
      break;
    }

    mergedList.push({ curr: curNode, prev: prevNode });
  }
  return mergedList;
};

export const isNavigationLoading = (state: RootState) => state.navigation.isLoading;

export const selectLevel0NavNodes = createSelector(
  selectRootNavigationIds,
  selectNavigationNodes,
  (level0Ids, nodesMap) => {
    return level0Ids.map((id) => nodesMap[id]);
  }
);

export const selectActiveLevel0Id = (state: RootState): number | undefined => selectSelectedNavIds(state)[0];
export const selectNode = (id: number) => (state: RootState) => selectNavigationNodes(state)[id];
export const selectIsNodeActive = (id: number) => (state: RootState) => selectSelectedNavIds(state).includes(id);
export const selectGoBackTitle = (visibleColAmount: number) => (state: RootState) => {
  const selectedIds = selectSelectedNavIds(state);
  const tileNodeId = selectedIds[selectedIds.length - (visibleColAmount + 1)];

  if (tileNodeId === undefined) {
    return "";
  }
  return selectNavigationNodes(state)[tileNodeId].title;
};

export const selectNavigationMenuLevel = (state: RootState) => selectSelectedNavIds(state).length;

export const selectFlyoutNodes = (state: RootState) => state.navigation.flyoutNodes;

export const selectNavigationDisplayMode = (state: RootState) => state.navigation.seriesTree.navigationMode;
